// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 MindTenet LLC
// This file is part of Undef Engine.

import { useLocation } from 'react-router-dom';
import { UserMenu } from './UserMenu';
import { useGameStore } from '../store/gameStore';

export function GlobalHeader() {
  const { displayName, sessionId, gameState } = useGameStore();
  const location = useLocation();

  // Don't show on admin or settings page (they have their own headers)
  if (location.pathname === '/admin' || location.pathname === '/settings') {
    return null;
  }

  // Don't show on WARP game pages (it has its own menu in header)
  const iswarp = (gameState as { game_id?: string } | null)?.game_id === 'warp';
  if (location.pathname.startsWith('/game/') && iswarp) {
    return null;
  }

  // Don't show on RoomList (it has its own UserMenu in header)
  // RoomList is shown when sessionId is null
  if (!sessionId) {
    return null;
  }

  // Only show if user has a display name (is logged in)
  if (!displayName) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-50">
      <UserMenu />
    </div>
  );
}
